import { z } from 'zod';
import { requestIdSchema, timestampSchema, activityType, apiResponseType, flowType, providerType, } from '@repo/shared/types';
var EVENT_CLICK_TYPE = apiResponseType.refine(function (type) { return type === 'EVENT_CLICK'; });
var providersSchema = z.object({
    enabled: z.array(providerType),
    selected: z.array(providerType),
});
var deviceSchema = z.object({
    type: z.string(),
    userAgent: z.string(),
    screenSize: z.string(),
});
export var eventClickRequestBodySchema = z.object({
    requestId: requestIdSchema,
    type: EVENT_CLICK_TYPE,
    activity: activityType,
    timestamp: timestampSchema,
    previousActivity: activityType.nullish(),
    nextActivity: activityType.nullish(),
    spentTime: z.number(),
    providers: providersSchema,
    flowType: flowType,
    device: deviceSchema,
});
